import { Injectable } from '@angular/core';
import { HttpService } from '../../../core/http.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '@base/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GetAgencyTcService extends HttpService {
  constructor(public override http: HttpClient) {
    super(http);
    this.url = '/agent';
    this.baseUrl = environment.apiEndpoint;
  }
}
